import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { ManagerDashboard } from './ManagerDashboard';
import { InventoryManagement } from '../inventory/InventoryManagement';
import { OrderManagement } from '../orders/OrderManagement';
import { CustomerManagement } from '../customers/CustomerManagement';
import { QualityControlManagement } from '../quality-control/QualityControlManagement';
import { MaintenanceManagement } from '../maintenance/MaintenanceManagement';
import { ProductionLineManagement } from '../production/ProductionLineManagement';
import { ProductionOperationsHub } from '../production/ProductionOperationsHub';
import { WorkOrderDetail } from '../production/WorkOrderDetail';
import { MachineFloor } from '../production/MachineFloor';
import { ProductionQueue } from '../production/ProductionQueue';
import { WarehouseManagement } from '../warehouse/WarehouseManagement';
import { DeliveryManagement } from '../delivery/DeliveryManagement';
import { FinancialDashboard } from '../financials/FinancialDashboard';
import { SupplyChainManagement } from '../supply-chain/SupplyChainManagement';
import { ReportGenerator } from '../reports/ReportGenerator';
import { ProductManagement } from '../products/ProductManagement';
import { ProductConfiguratorWrapper } from '../products/ProductConfiguratorWrapper';
import { ProductDisplayWrapper } from '../products/ProductDisplayWrapper';
import { useRbac } from '../../context/RbacContext';

const ManagerRoutes: React.FC = () => {
  const { hasPermission } = useRbac();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Routes>
        {/* Dashboard */}
        <Route 
          path="dashboard" 
          element={<ManagerDashboard />}
        />
        
        {/* Production Management */}
        <Route 
          path="production/operations" 
          element={<ProductionOperationsHub />}
        />

        <Route 
          path="production/work-orders/:id" 
          element={<WorkOrderDetail />}
        />

        <Route 
          path="production/machines" 
          element={<MachineFloor />}
        />

        <Route 
          path="production/lines" 
          element={<ProductionLineManagement />}
        />
        
        <Route 
          path="production/queue" 
          element={<ProductionQueue />}
        />

        <Route 
          path="warehouse" 
          element={<WarehouseManagement />}
        />

        <Route 
          path="deliveries" 
          element={<DeliveryManagement />}
        />

        <Route 
          path="financials" 
          element={<FinancialDashboard />}
        />
        
        {/* Business Operations */}
        <Route 
          path="inventory" 
          element={<InventoryManagement />}
        />
        
        <Route 
          path="orders" 
          element={<OrderManagement />}
        />
        
        <Route 
          path="customers" 
          element={<CustomerManagement />}
        />
        
        <Route 
          path="quality" 
          element={<QualityControlManagement />}
        />
        
        <Route 
          path="maintenance" 
          element={<MaintenanceManagement />}
        />
        
        <Route 
          path="supply-chain" 
          element={<SupplyChainManagement />}
        />
        
        <Route 
          path="reports" 
          element={<ReportGenerator />}
        />
        
        {/* Product Management */}
        <Route 
          path="products" 
          element={<ProductManagement />}
        />
        
        <Route 
          path="products/configurator/:productId" 
          element={<ProductConfiguratorWrapper />}
        />
        
        <Route 
          path="products/display/:productId" 
          element={<ProductDisplayWrapper />}
        />
        
        {/* Default route */}
        <Route 
          path="/" 
          element={<Navigate to="dashboard" replace />}
        />
        
        {/* Fallback route */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </Box>
  );
};

export default ManagerRoutes; 